import { makeStyles } from '@material-ui/core';
import { calculateHeight, calculateWidth, rem, vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';
import { baseColors } from '@ncr-retail/mui-theme';

const baseColor = baseColors();

export const transactionSearchModalStyles = makeStyles(theme => ({
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  labelHeadTop: {
    position: 'relative',
  },
  labelHead: {
    position: 'absolute',
    top: '50%',
    fontWeight: 500,
    color: themeColor.defaultTextColor,
    fontSize: rem(0.7),
    '@media (max-height: 1080px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.7),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.8),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.7),
    },
  },
  inputText: {
    '& > div > input': {
      color: themeColor.subheaderLight,
    },
    fontSize: rem(0.7),
    '@media (max-height: 1080px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.7),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.8),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.7),
    },
  },
  rowPaddingTop: {
    marginTop: '4vh',
    '@media  (width: 1024px) and (height: 576px)': {
      marginTop: '2vh',
    },
  },
  returnItemTitleBar: {
    color: themeColor.grayDivider,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: rem(2.08),
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
    width: vw(3),
  },
  returnItemTitleHeader: {
    color: themeColor.modalTitle,
    fontWeight: 500,
    fontSize: rem(2),
    paddingBottom: 5,
  },
  orSection: {
    color: themeColor.modalTitle,
    fontWeight: 500,
    fontSize: rem(1.2),
    paddingBottom: 20,
  },
  returnItemTitleSubheader: {
    color: themeColor.subheaderLight,
    fontWeight: 500,
    paddingBottom: '2vh',
    paddingTop: '2vh',
    fontSize: rem(0.7),
    '@media (max-height: 1080px)': {
      fontSize: rem(1.4),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1.1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.3),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.9),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(1),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.7),
    },
  },
  dateLabel: {
    position: 'absolute',
    top: 15,
    color: themeColor.defaultTextColor,
    fontWeight: 500,
    fontSize: rem(0.7),
    '@media (max-height: 1080px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.7),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.8),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.7),
    },
  },
  returnItemTitleHeaderInside: {
    color: themeColor.modalTitle,
    maxWidth: '35vw',
    textAlign: 'center',
    fontWeight: 500,
    fontSize: rem(1.2),
    paddingBottom: 10,
    whiteSpace: 'nowrap',
  },
  codeContainerSubHeaderLabel: {
    fontWeight: 500,
    '@media (max-height: 1080px)': {
      fontSize: `${rem(2.3)}!important`,
    },
    '@media (max-height: 900px)': {
      fontSize: `${rem(1.9)}!important`,
    },
    '@media (max-height: 768px)': {
      fontSize: `${rem(1.6)}!important`,
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: `${rem(1.9)}!important`,
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: `${rem(1.2)}!important`,
    },
    '@media (max-height: 720px)': {
      fontSize: `${rem(1.5)}!important`,
    },
    '@media (max-height: 576px)': {
      fontSize: `${rem(1.2)}!important`,
    },
  },
  returnItemContainer: {
    padding: 10,
  },
  keypadContainer: {
    alignSelf: 'flex-end',
  },
  fitHeight: {
    height: 'fit-content',
  },
  containerAlignment: {
    alignSelf: 'center',
    justifyContent: 'center',
  },
  selfAlign: {
    alignSelf: 'flex-end',
  },
  searchByTransactionDetailsButton: {
    width: vw(26),
    fontSize: rem(0.7),
    '@media (max-height: 1080px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.7),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.8),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.7),
    },
    marginBottom: vh(1.041),
  },
  policyButtons: {
    height: vh(4.4369),
    width: vw(7.5),
    textTransform: 'none',
    fontSize: rem(0.65),
    marginTop: 14,
    marginBottom: 8,
    marginLeft: 3,
    marginRight: 3,
    minHeight: 10,
    minWidth: '7vw',
    padding: 0,
    '@media (max-height: 1080px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.7),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.8),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.7),
    },
  },
  buttonStyles: {
    height: vh(7.4369),
    width: vw(11.81),
    fontSize: rem(0.75),
  },
  actionButtons: {
    height: vh(6.4369),
    width: vw(7.81),
    fontSize: rem(0.75),
    minHeight: vh(6.5),
    marginRight: 8,
    '@media (max-height: 1080px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.7),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.8),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.7),
    },
  },
  altActionButtons: {
    height: vh(6.4369),
    width: vw(14.12),
    fontSize: rem(0.75),
    minHeight: vh(6.5),
    marginRight: 8,
    '@media (max-height: 1080px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.7),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.8),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.7),
    },
  },
  searchButtonStyles: {
    height: vh(7.4369),
    width: vw(13.81),
    fontSize: rem(1.5),
    '@media (max-width: 1600px)': {
      fontSize: rem(1.2),
    },
    '@media (max-width: 1366px)': {
      fontSize: rem(1.1),
    },
    '@media (width: 1366px) and (height: 768px)': {
      fontSize: rem(1.1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.7),
    },
    '@media (max-width: 1280px)': {
      fontSize: rem(1),
    },
    '@media (max-width: 1024px)': {
      fontSize: rem(0.8),
    },
    '@media  (width: 1024px) and (height: 768px)': {
      fontSize: rem(1.1),
    },
    marginRight: vw(1.328),
    color: `${themeColor.white}!important`,
    backgroundColor: `${theme.palette.primary.main}!important`,
  },
  outerFlexDesgin: {
    flex: '1 1 0',
  },
  flexDesign: {
    flex: 1,
  },
  icon: {
    height: vh(5),
    width: vw(5),
  },
  cancelButton: {
    position: 'absolute',
    bottom: 0,
  },
  containerSeparator: {
    height: '0.2vh',
    background: themeColor.secondaryLight,
  },
  tbrListItems: {
    marginRight: '0.732vw',
  },
  categoryHeadStyle: {
    fontWeight: 500,
    color: themeColor.subheaderLight,
  },
  outerContainerStyle: {
    height: 'fit-content',
    paddingTop: '2vh',
  },
  datePadding: {
    paddingLeft: '1vw',
  },
  timePadding: {
    paddingLeft: '13vw',
    '@media (max-height: 1080px)': {
      paddingLeft: '12vw',
    },
    '@media (max-height: 768px)': {
      paddingLeft: '11.5vw',
    },
    '@media (max-height: 900px)': {
      paddingLeft: '12vw',
    },
    '@media (width: 1600px) and (height: 1200px)': {
      paddingLeft: '12vw',
    },
    '@media (width: 1024px) and (height: 768px)': {
      paddingLeft: '10.5vw',
    },
    '@media (max-height: 720px)': {
      paddingLeft: '12vw',
    },
    '@media (max-height: 576px)': {
      paddingLeft: '12vw',
    },
  },
  txnPadding: {
    paddingLeft: '12.5vw',
    '@media (max-height: 1080px)': {
      paddingLeft: '11.5vw',
    },
    '@media (max-height: 900px)': {
      paddingLeft: '11.5vw',
    },
    '@media (max-height: 768px)': {
      paddingLeft: '11vw',
    },
    '@media (width: 1600px) and (height: 1200px)': {
      paddingLeft: '10.5vw',
    },
    '@media (width: 1024px) and (height: 768px)': {
      paddingLeft: '10vw',
    },
    '@media (max-height: 720px)': {
      paddingLeft: '10.5vw',
    },
    '@media (max-height: 576px)': {
      paddingLeft: '11.5vw',
    },
  },
  posPadding: {
    paddingLeft: '9.5vw',
    '@media (max-height: 1080px)': {
      paddingLeft: '8vw',
    },
    '@media (max-height: 900px)': {
      paddingLeft: '8vw',
    },
    '@media (max-height: 768px)': {
      paddingLeft: '7vw',
    },
    '@media (width: 1600px) and (height: 1200px)': {
      paddingLeft: '7.5vw',
    },
    '@media (width: 1024px) and (height: 768px)': {
      paddingLeft: '5.5vw',
    },
    '@media (max-height: 720px)': {
      paddingLeft: '8vw',
    },
    '@media (max-height: 576px)': {
      paddingLeft: '9vw',
    },
  },
  storePadding: {
    paddingLeft: '6.5vw',
    '@media (max-height: 1080px)': {
      paddingLeft: '6.5vw',
    },
    '@media (max-height: 900px)': {
      paddingLeft: '6vw',
    },
    '@media (max-height: 768px)': {
      paddingLeft: '6.5vw',
    },
    '@media (width: 1600px) and (height: 1200px)': {
      paddingLeft: '6vw',
    },
    '@media (width: 1024px) and (height: 768px)': {
      paddingLeft: '5.5vw',
    },
    '@media (max-height: 720px)': {
      paddingLeft: '6vw',
    },
    '@media (max-height: 576px)': {
      paddingLeft: '6.5vw',
    },
  },
  valuePadding: {
    paddingLeft: '6.5vw',
    '@media (max-height: 1080px)': {
      paddingLeft: '5.5vw',
    },
    '@media (max-height: 900px)': {
      paddingLeft: '5.5vw',
    },
    '@media (max-height: 768px)': {
      paddingLeft: '5vw',
    },
    '@media (width: 1600px) and (height: 1200px)': {
      paddingLeft: '5vw',
    },
    '@media (width: 1024px) and (height: 768px)': {
      paddingLeft: '4vw',
    },
    '@media (max-height: 720px)': {
      paddingLeft: '5vw',
    },
    '@media (max-height: 576px)': {
      paddingLeft: '5.5vw',
    },
  },
  filterButtonStyle: {
    height: vh(5.4369),
    width: vw(7.5),
    textTransform: 'none',
    fontSize: rem(0.65),
    marginTop: 12,
    marginBottom: 12,
    marginLeft: 7,
    marginRight: 3,
    minHeight: 10,
    minWidth: '7vw',
    padding: 0,
    fontWeight: 500,
    '@media (max-height: 1080px)': {
      fontSize: rem(1.2),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.1),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(0.9),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.1),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.65),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.75),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.65),
    },
  },
  subHeaderStyle: {
    color: themeColor.modalTitle,
    fontWeight: 500,
  },
  centerAlign: {
    alignSelf: 'center',
  },
  leftMargin: {
    marginLeft: '2vw',
  },
  helperTextStyle: {
    color: themeColor.modalTitle,
    paddingBottom: 10,
    paddingTop: 10,
    fontWeight: 500,
    fontSize: rem(0.6),
    '@media (max-height: 1080px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.1),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.8),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.9),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.6),
    },
  },
  flexEndAlign: {
    alignSelf: 'flex-end',
  },
  bottomButtons: {
    height: vh(7.4369),
    width: vw(7.81),
    fontSize: rem(0.75),
    minHeight: vh(6.5),
    marginRight: 8,
  },
  tbrTransactionListContainer: {
    backgroundColor: themeColor.white,
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    minHeight: '6.07vh',
    border: `1px solid ${themeColor.secondaryLight}`,
    cursor: 'pointer',
    justifyContent: 'center',
  },
  outerDetailContainer: {
    justifyContent: 'flex-start',
  },
  row: {
    justifyContent: 'space-between',
    paddingLeft: '1.1713vw',
  },
  innerDetailInformationContainer: {
    fontSize: rem(0.875),
    '@media (max-height: 1080px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.1),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.8),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.9),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.6),
    },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: baseColor.bigstone,
  },
  selected: {
    border: `2px solid ${theme.palette.secondary.main}`,
    '& .search-result-image': {
      width: '4.02vw',
      height: '7.16vh',
      marginTop: '0.13vh',
    },
  },
  rejectButton: {
    marginRight: '1.7vw',
    border: `1px solid ${themeColor.secondaryLight}`,
    color: themeColor.defaultTextColor,
    fontSize: rem(1),
    fontWeight: 500,
    lineHeight: '24px',
  },
  calendarMonthNavButtons: {
    padding: 8,
    border: `1px solid ${themeColor.lightgray}`,
    borderRadius: 2,
    boxShadow: `0px 1px 2px ${themeColor.lightgray}`,
  },
  calendarNavHeader: {
    position: 'relative',
    height: 46,
  },
  calendarNavMonthYear: {
    position: 'absolute',
    top: 10,
    left: 21,
    color: themeColor.palesky,
    fontWeight: 500,
  },
  calendarNavButtonHead: {
    position: 'relative',
    top: 4,
  },
  calendarNavBack: {
    position: 'absolute',
    right: 85,
  },
  calendarNavForward: {
    position: 'absolute',
    right: 20,
  },
  alignCenter: {
    alignSelf: 'center',
    textAlign: 'center',
    marginBottom: vh(10),
    '@media (max-width: 1024px) and (max-height: 576px)': {
      marginLeft: vw(3),
    },
    '@media (max-width: 1024px) and (min-height: 768px)': {
      marginLeft: vw(11),
    },
    '@media (min-width: 1280px) and (min-height: 720px)': {
      marginLeft: vw(3),
    },
    '@media (min-width: 1366px) and (min-height: 768px)': {
      marginLeft: vw(3),
    },
    '@media (min-width: 1600px) and (min-height: 1200px)': {
      marginLeft: vw(11),
    },
    '@media (min-width: 1600px) and (max-height: 900px)': {
      marginLeft: vw(3),
    },
    '@media (min-width: 1920px) and (min-height: 1080px)': {
      marginLeft: vw(3),
    },
  },
  qtyCenter: {
    justifyContent: 'flex-start',
    alignSelf: 'center',
    '@media (min-width: 1024px) and (min-height: 576px)': {
      marginLeft: vw(5.45),
    },
    '@media (min-width: 1024px) and (min-height: 768px)': {
      marginLeft: vw(8.45),
    },
    '@media (min-width: 1280px) and (min-height: 720px)': {
      marginLeft: vw(5.45),
    },
    '@media (min-width: 1366px) and (min-height: 768px)': {
      marginLeft: vw(5.45),
    },
    '@media (min-width: 1600px) and (min-height: 900px)': {
      marginLeft: vw(5.55),
    },
    '@media (min-width: 1600px) and (min-height: 1200px)': {
      marginLeft: vw(8.55),
    },
    '@media (min-width: 1920px) and (min-height: 1080px)': {
      marginLeft: vw(6),
    },
  },
  modalText: {
    font: 'Roboto',
    fontWeight: 500,
    fontSize: vw(2),
    marginBottom: rem(2.5),
  },
  iconStyle: {
    '@media (max-height: 1080px)': {
      fontSize: rem(2),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.8),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1.5),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(2.1),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(1),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(0.9),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.7),
    },
  },
  dialogPaper: {
    minHeight: '95.96vh',
    maxHeight: '95.96vh',
    minWidth: '97.51vw',
    maxWidth: '97.51vw',
    borderRadius: 'unset',
    backgroundColor: themeColor.lightBackground,
  },
  trainingModeBackground: {
    minHeight: '95.96vh',
    maxHeight: '95.96vh',
    backgroundColor: themeColor.trainingBackground,
  },
  filterTextContainer: {
    width: '10%',
  },
  filterButtonsContainer: {
    width: '30%',
  },
  outerContainerPadding: {
    padding: '2vh',
  },
  autoFlex: {
    flex: 'auto',
  },
  resultListContainerWidth: {
    width: '75%!important',
    '@media (max-height: 768px)': {
      width: '74%!important',
    },
    '@media (width: 1024px) and (height: 768px)': {
      width: '70%!important',
    },
    '@media (max-height: 576px)': {
      width: '75%!important',
    },
  },
  keypadContainerWidth: {
    marginLeft: 'auto!important',
    justifyContent: 'flex-end',
    '@media (max-height: 576px)': {
      width: '23%!important',
    },
  },
  searchButtonStyle: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  customTopMargin: {
    marginTop: '-5vh',
  },
  contentAlign: {
    alignContent: 'flex-start',
  },

  textFieldInput: {
    height: calculateHeight(50).stringValue,
    width: calculateWidth(420).stringValue,
    fontSize: rem(1.125),
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: '2px 2px 0',
    outline: 'hidden',
    marginLeft: '15vw',
    marginRight: '1vh',
    top: '2.5vh',
  },

  containerHeight: {
    height: '15.5%',
  },

  showOverflow: {
    overflow: 'inherit',
  },
}));
